import React, {useEffect, useState} from 'react';
import ReactDOM from "react-dom/client";
import queryString from 'query-string';
import useFetchData from './fetcher';
import FilterSearch from './filter-search';
import CustomerStoryFilters from './customer-story-filters';
import Pagination from './pagination';
import LoadingAnimation from './loading-animation';
import NoResults from './no-results';

import './scss/customer-story-index.scss';


const CustomerStoryIndexApp = (props) => {
  const langcode = (drupalSettings.path.currentLanguage == 'en') ? '/' : '/' + drupalSettings.path.currentLanguage + '/';
  const fetchUrl = langcode + 'rest-api/cp-customer-story-index-data';
  const [fetch, setFetch] = useState(fetchUrl);
  const [filters, setFilters] = useState({search: '', industry: '', spots: ''});
  const [isReady, setIsReady] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Grab the search and filters from the query string on the first run.
    const parsed = queryString.parse(location.hash);

    setFilters(parsed);

    setIsReady(true);
  }, []);

  // Fetch data from the rest resource.
  useEffect(() => {
    if (isReady) {
      useFetchData(fetch, setData, setLoading);
    }
  }, [fetch]);

  // Build the fetch url based on search and filters.
  useEffect(() => {
    setLoading(true);
    if (isReady) {
      // Update browser hash with the current filters and set new fetch url.
      location.hash = queryString.stringify(filters);
      setFetch(`${fetchUrl}?${queryString.stringify(filters)}`);
    }
  }, [filters]);

  const scrollTop = () => {
    // Scroll to top of the app. 
    const appDiv = document.getElementsByClassName(props.appDiv)[0];
    window.scrollTo({
      top: appDiv.offsetTop + 40,
      behavior: "smooth"
    });
  }

  return (
    <>
      {loading && <LoadingAnimation />}
      {(!loading) && (
        <div className='filters'>
          <CustomerStoryFilters dataFilters={data.filters} setFilters={setFilters} filters={filters} isReady={isReady} />
        </div>
      )}

      {/* List Blog posts. */}
      <div className='list'>
        {(!loading) && (
          <div className='search'>
            <h4 className="hide">{Drupal.t('Looking for something specific?')}</h4>
            <FilterSearch filters={filters} isReady={isReady} loading={loading} list={data.customer_stories} pagination={data.pagination} setFilters={setFilters} searchFor={Drupal.t('Customer Stories')} />
          </div>
        )}

        {(!loading && data.customer_stories && data.filters) && (
          <div className='customer-story-list'>
            {(data.customer_stories.length > 0) ? data.customer_stories.map((item, i) => (
              <a key={i} className="item" href={item.node_alias}>
                <div className="c-logo py24 justify-between grid-cell--justify-center ">
                  <img src={item.image} alt={item.title} className='thumb_image' loading='lazy' />
                </div>
                <div className='title tac'>
                   <h4>{item.title}</h4>
                   
                </div>
                <p className="read-more">{Drupal.t('Read more')}</p>
              </a>
            )) : (
              <NoResults setFilters={setFilters} />
            )}
          </div>
        )}

        {/* Pagination */}
        {(!loading && data.pagination && data.pagination.pages > 1) && (
          <Pagination pagination={data.pagination} setFilters={setFilters} filters={filters} isReady={isReady} scrollTop={scrollTop} />
        )}
      </div>
    </>
  );
};

const appDiv ='cp-customer-story-index-app';
const appRoot = document.querySelectorAll(`.${appDiv}`);
appRoot.forEach((element) => {
  const root = ReactDOM.createRoot(element);
  root.render(
    <React.StrictMode>
      <CustomerStoryIndexApp appDiv={appDiv} />
    </React.StrictMode>
  );
});
